export default __webpack_public_path__ + "static/dedication-94633b33f96121f17ad5af4f8ce4bb9d.png";